export default [
  {
    value: 'MARGEM',
    text: 'Margem',
  },
  {
    value: 'TAXA',
    text: 'Taxa',
  },
];
